var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'access',
  created () {
  },
  data () {
    return {
      csvFileName: null,
      canValidate: true,
      join: {
        start_date: null,
        end_date: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        after_release: (!!this.join.start_date && (this.start_date >= '2018-01-04')) &&
                        (!!this.join.end_date && (this.end_date >= '2018-01-04')),
        integrity: this.join.start_date > this.join.end_date,
        not_input: (!!this.join.start_date && (this.start_date >= '2018-01-04')) &&
                   (!!this.join.end_date && (this.end_date >= '2018-01-04')) &&
                   (this.join.start_date <= this.join.end_date)
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    users () {
      return this.$store.getters.csvUsers
    },
    start_date: function() {
      return this.join.start_date.getFullYear() + '-' + ("0" + (this.join.start_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.join.start_date.getDate()).slice(-2)
    },
    end_date: function() {
      return this.join.end_date.getFullYear() + '-' + ("0" + (this.join.end_date.getMonth() + 1)).slice(-2) + '-' + ("0" + this.join.end_date.getDate()).slice(-2)
    }
  },
  components: {
    AppHeader
  },
  methods: {
    downloadCsv: function () {
      var self = this
      var data = {}
      data.start_date = this.start_date
      data.end_date = this.end_date
      var callback = function() {
        self.csvFileName = self.start_date.replace( /-/g, '') + '-' + self.end_date.replace( /-/g, '') + '_' + '入社社員' +'.csv'

        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var mimeType = 'text/csv'
        var csv = '社員ID,会社コード,社員名,社員名(カナ),携帯電話番号,郵便番号,住所,生年月日,性別,入社日,店舗名,Email\n'
        self.users.forEach(function (obj) {
          csv += obj.attributes['login-id'] + ","
          csv += "05" + ","
          if (obj.attributes['user-name']) {
            csv += obj.attributes['user-name'].replace( /,/g, '') + '　' + obj.attributes['user-firstname'] + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-name-furigana'] && obj.attributes['user-firstname-furigana']) {
            csv += self.hiraganaToKatakana(obj.attributes['user-name-furigana'].replace( /,/g, '') + ' ' + obj.attributes['user-firstname-furigana'].replace( /,/g, '')) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-mobile']) {
            csv += obj.attributes['user-mobile'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-post-no']) {
            csv += obj.attributes['user-post-no'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-address']) {
            csv += obj.attributes['user-address'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-birthday']) {
            csv += obj.attributes['user-birthday'].replace( /[-,]/g, '/') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-sex']) {
            csv += self.csv_sex(obj.attributes['user-sex']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-joinday']) {
            csv += obj.attributes['user-joinday'].replace( /[-,]/g, '/') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['shop-name']) {
            csv += obj.attributes['shop-name'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['email']) {
            csv += obj.attributes['email'].replace( /,/g, '')
          }
          csv += "\n"
        })
        var blob = new Blob([bom, csv], { type: mimeType })
        var hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if(window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL){
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        } else {
          window.open('data:' + mimeType + ';base64,' + window.Base64.encode(content), '_blank')
        }
      }
      self.$store.dispatch('ACCESS_CSV',{ data : data, callback : callback })
    },
    onClickCancel: function () {
      this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
    },
    csv_sex: function(sex) {
      if (sex == 'man') {
        return 0
      } else if (sex == 'woman') {
        return 1
      } else {
        return ''
      }
    },
    hiraganaToKatakana: function(str) {
      return str.replace(/[\u3041-\u3096]/g, function(match) {
        var chr =  match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/access.js